<template>
    <v-container pt-2>
        <v-layout column>
            <a-date-field 
               xs12 label="Período entre" v-model="filterData.dateRange[0]" 
               validate="dateDMY" dateFormat="DD/MM/YYYY" clearable
            ></a-date-field>
            <a-date-field 
               xs12 label="e" v-model="filterData.dateRange[1]" 
               validate="dateDMY" dateFormat="DD/MM/YYYY" clearable
            ></a-date-field>

            <a-select-field 
               label="Totalizar por" :suggestions="sumTypes"
               v-model="filterData.sumType"
            ></a-select-field>

            <a-select-field 
               clearable label="Apenas referente ao banco" 
               obj="bank" sm4 v-model="filterData.bankId"
            ></a-select-field>

            <a-select-field 
               clearable label="Apenas referente ao convênio" 
               obj="covenant" sm4 v-model="filterData.covenantId"
            ></a-select-field>

            <a-select-field 
               clearable label="Por Afiliado" 
               sm4 :suggestions="affiliates" 
               v-model="filterData.affiliateId"
            ></a-select-field>

            <a-select-field 
               v-if="filterData.affiliateId && subAffiliates.length"
               clearable label="Por Sub Afiliado" 
               sm4 :suggestions="subAffiliates" 
               v-model="filterData.subAffiliateId"
            ></a-select-field>

            <a-select-field 
               clearable label="Por campanha" 
               :suggestions="campaigns" ref="campaignField"
               sm4 v-model="filterData.campaignId"
            ></a-select-field>

            <a-select-field clearable label="Produto" obj="productType"
               v-model="filterData.productTypeId" ref="productTypeField"></a-select-field>
        </v-layout>
    </v-container>
</template>

<script>

   export default {
      props: {
         reloadKey: {
            type: Number,
            required: false
         },
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data: () => ({
         banks: [],
         covenants: [],
         affiliates: [],
         subAffiliates: [],
         campaigns: [],

         filterData: {
            bankId: null,
            covenantId: null,
            sumType: 'daily',
            dateRange: [null, null],
            affiliateId: null,
            subAffiliateId: null,
            campaignId: null,
            productTypeId: null,
         },

         sumTypes: [
            {id: 'daily', name: 'Dia'},
            {id: 'weekly', name: 'Semana'},
            {id: 'monthly', name: 'Mês'},
            {id: 'yearly', name: 'Ano'}
         ]
      }),

      watch: {
         'filterData.affiliateId': async function(value) {
            if (value) {
               this.filterData.subAffiliateId = null;
               
               let subAffiliates = await this.$api.dataService.execute('affiliate/getSubAffiliates', { referrerId: value });
               this.subAffiliates = subAffiliates;
            }
         },
         reloadKey: {
            immediate: true,
            handler: function () {
               this.$nextTick(() => this.reloadFilters());
            }
         },
         execute(val) {
            val && this.applyFilter();
         }
      },

      methods: {
         applyFilter() {
            let filters = [];

            let rangeLabel = '';
            if (this.filterData.dateRange) {
               let dateRange = this.filterData.dateRange.filter(d => d !== null);
               dateRange.forEach((v, i) => dateRange[i] = this.$moment(v).format('YYYY-MM-DD'));

               if (dateRange.length === 2)
                  rangeLabel += (dateRange[0] === dateRange[1]) ? 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY') : `Entre ${this.$moment(dateRange[0]).format('DD/MM/YYYY')} e ${this.$moment(dateRange[1]).format('DD/MM/YYYY')} `;
               else if (dateRange.length)
                  rangeLabel += 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY');
               else
                  rangeLabel = '';

               if (!rangeLabel) {
                  this.filterData.dateRange = [null, null];
               }
            }

            let bankName;
            this.filterData.bankId ? bankName = this.banks.find(el => el.id == this.filterData.bankId).name : bankName = null;
            filters.push({field: 'bankId', value: this.filterData.bankId, label: bankName ? bankName : null});

            let covenantName;
            this.filterData.covenantId ? covenantName = this.covenants.find(el => el.id == this.filterData.covenantId).name : covenantName = null;
            filters.push({field: 'covenantId', value: this.filterData.covenantId, label: covenantName ? covenantName : null});

            filters.push({field: 'clientId', value: this.filterData.clientId, label: 'Cliente'});

            let affiliateName;
            this.filterData.affiliateId ? affiliateName = this.affiliates.find(el => el.id == this.filterData.affiliateId).name : affiliateName = null;

            let subAffiliateName;
            this.filterData.subAffiliateId ? subAffiliateName = this.subAffiliates.find(el => el.id == this.filterData.subAffiliateId).name : subAffiliateName = null;

            let campaignName;
            if(this.filterData.campaignId  && this.$refs.campaignField && this.$refs.campaignField.items.length){
               let auxText = this.$refs.campaignField.items.find(el => el.id == this.filterData.campaignId);
               campaignName = auxText && auxText.name ? auxText.name : null
            }
            filters.push({field: 'campaignId', value: this.filterData.campaignId, label: campaignName});

            let productTypeName;
            this.filterData.productTypeId ? productTypeName = this.$refs.productTypeField.items.find(el => el.id == this.filterData.productTypeId).name : productTypeName = null;
            filters.push({ field: 'productTypeId', value: this.filterData.productTypeId, label: productTypeName });

            let typeLabel = this.sumTypes.filter(t => t.id === this.filterData.sumType)[0].name;
            filters.push({field: 'sumType', value: this.filterData.sumType, label: 'Totalizado por ' + typeLabel});
            filters.push({field: 'dateRange', value: this.filterData.dateRange, label: rangeLabel});
            filters.push({field: 'affiliateId', value: this.filterData.affiliateId, label: affiliateName});
            filters.push({field: 'subAffiliateId', value: this.filterData.subAffiliateId, label: subAffiliateName});

            this.$store.dispatch('updateAllPageFilters', filters);
            setTimeout(() => this.$emit('close'), 150);
         },

         reloadFilters() {
            let currentFilters = this.$store.getters.activePageFilters;

            this.$util.updateObj(this.filterData, currentFilters);
            if (!this.filterData.dateRange) {
               this.filterData.dateRange = [null, null];
            }
         }
      },
      async created() {
         this.banks = await this.$api.dataService.search('bank');
         this.covenants = await this.$api.dataService.search('covenant');
         this.affiliates = await this.$api.dataService.execute('affiliate/getMyBrandAffiliates', {});
         this.campaigns = await this.$api.dataService.execute('campaign/getMyBrandLinks', {});
      }
   }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/DashboardFilter.vue